import { Pipe, PipeTransform } from '@angular/core';

import { CONTATOS_INICIATIVAS } from '../contato-iniciativa';

@Pipe({
    name: 'contatoIniciativa'
})
export class ContatoIniciativaPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = CONTATOS_INICIATIVAS.findIndex(iniciativa => iniciativa.id === value);
        if (index > -1) {
            return CONTATOS_INICIATIVAS[index].nome;
        }
        return '';
    }
}
